module.exports = __webpack_public_path__ + "static/media/img-coming-soon.8700aee2.jpg";